export enum MerchantUserSensitiveTypeEnum {
  ORDER_CANCEL = 0,
  ITEM_CANCEL = 1,
  ITEM_SPECIFIED_DISCOUNT = 2,
  ITEM_SPECIFIED_WAIVER = 3,
  DISCOUNT_TYPE_MANUAL = 4,
  DISCOUNT_TYPE_MANUAL_DISCOUNT = 5,
  HANG_ORDER = 6,
  REVERSE_CLOSE_ORDER = 7,
  REVOKE_MEMBER_CHARGE = 8,
  REVOKE_CREDIT_RECORD = 9,
  CANCEL_CREDIT_RECORD = 10,
  TABLE_CHECKOUT_TIME_UPDATE = 11,
  TABLE_OPEN_TIME_UPDATE = 12,
  DISCOUNT_TYPE_MANUAL_ZERO = 13,
  SHIFT_HANDOVER_RETAINED_CASH_UPDATE = 14,
}

export const MerchantUserSensitiveTypeDescriptions: { [key in MerchantUserSensitiveTypeEnum]: string } = {
  [MerchantUserSensitiveTypeEnum.ORDER_CANCEL]: "取消订单",
  [MerchantUserSensitiveTypeEnum.ITEM_CANCEL]: "取消商品",
  [MerchantUserSensitiveTypeEnum.ITEM_SPECIFIED_DISCOUNT]: "商品手动打折",
  [MerchantUserSensitiveTypeEnum.ITEM_SPECIFIED_WAIVER]: "商品手动减免",
  [MerchantUserSensitiveTypeEnum.DISCOUNT_TYPE_MANUAL]: "整单手动打折",
  [MerchantUserSensitiveTypeEnum.DISCOUNT_TYPE_MANUAL_DISCOUNT]: "整单手动减免",
  [MerchantUserSensitiveTypeEnum.HANG_ORDER]: "挂单",
  [MerchantUserSensitiveTypeEnum.REVERSE_CLOSE_ORDER]: "反结账",
  [MerchantUserSensitiveTypeEnum.REVOKE_MEMBER_CHARGE]: "会员充值撤销",
  [MerchantUserSensitiveTypeEnum.REVOKE_CREDIT_RECORD]: "作废积分使用记录",
  [MerchantUserSensitiveTypeEnum.CANCEL_CREDIT_RECORD]: "取消核销积分记录",
  [MerchantUserSensitiveTypeEnum.TABLE_CHECKOUT_TIME_UPDATE]: "修改桌台结账时间",
  [MerchantUserSensitiveTypeEnum.TABLE_OPEN_TIME_UPDATE]: "修改桌台开台时间",
  [MerchantUserSensitiveTypeEnum.DISCOUNT_TYPE_MANUAL_ZERO]: "抹零",
  [MerchantUserSensitiveTypeEnum.SHIFT_HANDOVER_RETAINED_CASH_UPDATE]: "修改交接班开班留存",
}
